import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { FC } from 'react';
import { hthHelper } from '@/services';
import { ImArrowDown } from 'react-icons/im';
import { typeHTHHousehold } from '@monorepo/models';

type propsType = {
    changeCallingStateHandler: (household: typeHTHHousehold, callingState?: number) => void;
    closeHandler: () => void;
    selectedHousehold: typeHTHHousehold;
};

export const HTHHouseholdState: FC<propsType> = ({
    changeCallingStateHandler, closeHandler, selectedHousehold
}) => {

    return (
        <div className={'mt-4'}>
            <div className={'d-flex justify-content-center mb-3'}>
                <div className={'row d-flex justify-content-start bg-dark text-white border rounded text-center my-2'}
                    style={{
                        marginInline: '10px',
                        height: '50px',
                        paddingTop: '10px',
                        width: '125px'
                    }}
                >
                    <div className={'col-3'}>
                        <ImArrowDown size={25}
                            className={'animate__animated animate__bounce  animate__slower animate__infinite infinite ms-1'}
                        />
                    </div>
                    <div className={'col-9'}>
                        <label
                            className={`${(selectedHousehold.isManager || selectedHousehold.doorName!.length > 5) ?
                                'animate__animated animate__fadeInLeft animate__slow animate__infinite infinite'
                                :
                                ''} pointer fw-bold mx-auto`
                            }
                            style={{
                                marginTop: '2px',
                                overflowX: 'hidden',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {selectedHousehold.isComplexBuilding ?
                                selectedHousehold.doorName
                                :
                                <>
                                {selectedHousehold.isManager ?
                                    'Portería'
                                    : selectedHousehold.level === 0 ?
                                    `PB ${selectedHousehold.doorName}`
                                    :
                                    `${selectedHousehold.level}° ${selectedHousehold.doorName}`
                                }
                                </>
                            }
                        </label>
                    </div>
                </div>
            </div>
            <div className={'d-flex flex-column align-items-center text-center'}>
                {!selectedHousehold.isChecked &&
                    <button className={'btn btn-general-red btn-size12 border border-light text-start py-2 mt-2 mb-3'}
                        style={{ paddingLeft: '64px', width: '300px' }} 
                        onClick={() => changeCallingStateHandler(selectedHousehold, 1)}
                    >
                        <FaCheckCircle size={25} className={'me-2'} style={{ marginBottom: '1px' }} /> <span className={'fw-bold'}>Atendieron</span>
                    </button>
                }
                {!selectedHousehold.isCheckedNotAnswered &&
                    <button className={'btn btn-yellow btn-size12 border border-light text-start py-2 mb-3'}
                        style={{ paddingLeft: '64px', width: '300px' }}
                        onClick={() => changeCallingStateHandler(selectedHousehold, 2)}
                    >
                        <FaTimesCircle size={25} className={'me-2'} style={{ marginBottom: '1px' }} /> <span className={'fw-bold'}>No Atendieron</span>
                    </button>
                }
                {(selectedHousehold.isChecked || selectedHousehold.isCheckedNotAnswered) && hthHelper.IsAllowedToChangeState(selectedHousehold) &&
                    <button className={'btn btn-green btn-size12 border border-light text-start py-2 mb-3'}
                        style={{ paddingLeft: '64px', width: '300px' }}
                        onClick={() => changeCallingStateHandler(selectedHousehold, 0)}
                    >
                        <FaTimesCircle size={25} className={'me-2'} style={{ marginBottom: '1px' }} /> <span className={'fw-bold'}>Desmarcar</span>
                    </button>
                }
                <button className={'btn btn-dark btn-size12 border border-light text-start py-2 mb-3'}
                    style={{ paddingLeft: '64px', width: '300px' }}
                    onClick={closeHandler}
                >
                    <FaTimesCircle size={25} className={'me-2'} style={{ marginBottom: '1px' }} /> <span className={'fw-bold'}>Cancelar</span>
                </button>
            </div>
        </div>
    );
}
